import { useEffect } from 'react';

const OrderTableStyles = () => {
  useEffect(() => {
    const styleId = 'order-highlight-animation';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.innerHTML = `
        @keyframes highlightNewOrder {
            0% { background-color: rgba(167, 243, 208, 0.9); }
            10% { background-color: rgba(167, 243, 208, 0.95); }
            30% { background-color: rgba(167, 243, 208, 0.8); }
            70% { background-color: rgba(167, 243, 208, 0.6); }
            100% { background-color: transparent; }
        }
        
        .highlight-new-order {
            animation: highlightNewOrder 7s ease-out forwards;
            background-color: rgba(167, 243, 208, 0.7);
        }
        
        /* Add animations for sync status icons */
        @keyframes pulseSuccess {
            0% { transform: scale(1); opacity: 0.9; }
            50% { transform: scale(1.1); opacity: 1; }
            100% { transform: scale(1); opacity: 0.9; }
        }
        
        @keyframes pulseError {
            0% { transform: scale(1); opacity: 0.9; }
            25% { transform: scale(1.1) rotate(5deg); opacity: 1; }
            50% { transform: scale(1); opacity: 0.9; }
            75% { transform: scale(1.1) rotate(-5deg); opacity: 1; }
            100% { transform: scale(1); opacity: 0.9; }
        }
        
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
        
        .sync-success {
            animation: pulseSuccess 2s infinite ease-in-out;
        }
        
        .sync-error {
            animation: pulseError 2s infinite ease-in-out;
        }
        
        .sync-loading {
            animation: spin 1.5s linear infinite;
        }
        
        .sync-indicator {
            transition: all 0.3s ease-in-out;
        }
        
        .sync-indicator:hover {
            transform: scale(1.15);
        }
      `;
      document.head.appendChild(style);
    }

    return () => {
      const styleElement = document.getElementById(styleId);
      if (styleElement) {
        document.head.removeChild(styleElement);
      }
    };
  }, []);

  return null;
};

export default OrderTableStyles;